import React from "react";
import { useTheme, Box } from "@mui/material"

const AlertBallIcon = ({ top = 2, right = 1, size = '9px', color, show = true, zIndex = 1 }) => {

  const theme = useTheme();

	return (
		<Box
			sx={{
				position: "absolute",
				width: size,
				height: size,
				backgroundColor: color || theme.palette.error.main,
				borderRadius: "50%",
				zIndex: zIndex,
				top: top,
        right: right,
				display: show ? "block" : "none",
			}}
		/>
	);
};
export default AlertBallIcon;


